export default __webpack_public_path__ + "media/arrow-right-orange.54c2960c.svg";